export enum EmploymentType {
  PartTime = "PART_TIME",
  FullTime = "FULL_TIME",
  Temporary = "TEMPORARY"

}
